import { Link } from 'react-router-dom';
import { useSiteConfig } from '../context/SiteConfigContext';

/**
 * Renders site logo from admin settings (icon / text / icon+text) with light/dark assets.
 */
export default function BrandLogo({ className = '', linkTo = '/', theme = 'light', showText = true }) {
  const { config } = useSiteConfig();
  const logoType = config.logo_type || 'icon_text';
  const isDark = theme === 'dark';

  const imageUrl = isDark
    ? config.logo_dark_url || config.logo_light_url || config.logo_icon_url
    : config.logo_light_url || config.logo_icon_url || config.logo_dark_url;

  const showIcon = logoType === 'icon' || logoType === 'icon_text';
  const showLabel = showText && (logoType === 'text' || logoType === 'icon_text') && config.logo_text;

  const inner = (
    <>
      {showIcon && imageUrl ? (
        <img
          src={imageUrl}
          alt={config.site_name || 'Logo'}
          className="brand-logo-img"
        />
      ) : null}
      {showLabel ? (
        <span className="brand-text">{config.logo_text}</span>
      ) : null}
      {!showIcon && !showLabel ? (
        <span className="brand-text">{config.site_name || 'Polyrion'}</span>
      ) : null}
    </>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className={`brand ${className}`.trim()}>
        {inner}
      </Link>
    );
  }

  return <div className={`brand ${className}`.trim()}>{inner}</div>;
}
